import { FC } from "react";
// Assets
import PrivacyHeroImage from "../../assets/images/privacyHero.svg";
import NavBar from "../../components/NavBar";
import TitleIcon from "../../assets/images/titleIcon.svg";
import Footer from "../../components/Footer";
interface Props {
  title: string;
}
const Title: FC<Props> = (props) => (
  <div className=" flex text-blue mb-2 ">
    <img src={TitleIcon} alt="TitleIcon" />
    <span className=" font-bold	text-lg md:text-2xl ml-3 ">{props.title}</span>
  </div>
);

export default function PrivacyPolicy() {
  return (
    <div className="flex flex-col items-center  min-h-screen bg-gray-100 p-4 md:pt-14 md:pl-40 md:pr-40 overflow-y-auto ">
      <div>
        <img src={PrivacyHeroImage} alt="PrivacyHeroImage" className=" mb-6" />
        <NavBar />
      </div>
      <div className=" text-white  w-full text-left pt-4  md:pt-12 md:pb-10">
        <h1 className="md:text-3xl text-xl font-bold text-gray  text-left">
          Privacy Policy for Maani
        </h1>
      </div>
      <div className="mt-6 text-left w-full md:text-base text-sm text-gray leading-8	">
        <p>
          Thank you for using Maani. Your privacy is very important to us, and
          we are committed to maintaining the trust and confidence of our users.
          This Privacy Policy explains how we handle any information collected
          through your use of the Maani app and our related services.
          <br />
          <br />
          By using Maani, you agree to the collection and use of information as
          described in this policy.
        </p>
        <br />
        <Title title="About Maani" />
        <p>
          Maani is a loan discovery platform that helps users explore loan plans
          from trusted merchants without the need to collect any personal data.
          Our app allows users to browse and review different loan options
          without requiring personal details such as names, email addresses, or
          financial information.
        </p>
        <br />
        <Title title="What Data we collect" />
        <h3 className="md:text-lg text-base  text-gray font-bold text-left mb-1">
          No Personal Data Collection
        </h3>
        <p>
          Maani does not collect, store, or share any personal information. Our
          app is designed to offer a loan discovery experience without requiring
          user registration or the submission of any personal data.
        </p>
        <br />
        <h3 className="md:text-lg text-base  text-gray font-bold text-left mb-1">
          Automatically Collected Information
        </h3>
        <p>
          We do not automatically collect any personal data, such as IP
          addresses or device identifiers. However, third-party services that
          users may navigate to through external links within the app (such as
          loan merchant websites) may have their own data collection practices.
          We encourage you to review the privacy policies of these third
          parties.
        </p>
        <br />
        <Title title="How we use collected information" />
        <p>
          Since Maani does not collect any personal data, there is no personal
          information to process or use. Any information that may be collected
          by third-party services or linked merchants is outside our control and
          is governed by the privacy policies of those third-party services.
        </p>
        <br />
        <Title title="Sharing your data" />
        <p>
          As we do not collect any personal information, Maani does not share
          any user data with third parties. However, users who navigate to
          external sites through Maani (such as loan merchant websites) may be
          subject to data collection by those sites. Please review the privacy
          policies of those external sites before sharing any personal data.
        </p>
        <br />
        <Title title="Cookie and tracking technologies" />
        <h4 className="md:text-base text-sm  text-gray font-bold text-left mb-1">
          Maani does not use cookies or similar tracking technologies to collect
          data on our users.
        </h4>
        <br />
        <p>
          However, third-party services or linked websites accessed through the
          Maani app may use cookies to track your activity. We do not have
          control over these third parties and their use of cookies. Please
          review their privacy policies for more information about their data
          collection practices.
        </p>
        <br />
        <Title title="Your Privacy Rights" />
        <p>
          Maani respects the privacy rights of all users, including those
          provided under regulations such as the General Data Protection
          Regulation (GDPR) and the California Consumer Privacy Act (CCPA).
        </p>
        <h3 className="md:text-lg text-base  text-gray font-bold text-left mb-1">
          For EU Residents (GDPR)
        </h3>
        <p>
          Under the GDPR, EU residents have certain rights regarding their
          personal data, including the right to access, correct, or delete
          information. Since Maani does not collect personal data, we do not
          retain any information that can be accessed or deleted.
        </p>
        <br />
        <h3 className="md:text-lg text-base  text-gray font-bold text-left mb-1">
          For California Residents (CCPA)
        </h3>
        <p>
          Under the CCPA, California residents have the right to know what
          personal data is being collected about them and to request that it be
          deleted. As Maani does not collect personal data, there is no
          information to disclose or delete.
        </p>
        <br />
        <p>
          If you interact with third-party services or merchants through Maani,
          please contact them directly for any requests related to your personal
          data.
        </p>
        <br />
        <h3 className="md:text-lg text-base  text-gray font-bold text-left mb-1">
          Account Information
        </h3>
        <p>
          If you would at any time like to review or change the information in
          your account or terminate your account, you can: <br />
          <ul className="list-disc pl-5 mt-2">
            <li className="text-gray">
              Contact us using the contact information provided.
            </li>
          </ul>
          Upon your request to terminate your account, we will deactivate or
          delete your account and information from our active databases.
          However, we may retain some information in our files to prevent fraud,
          troubleshoot problems, assist with any investigations, enforce our
          legal terms and/or comply with applicable legal requirements. If you
          have questions or comments about your privacy rights, you may email us
          at
          <a
            href="mailto:contact@mymaani.com?subject=Support Inquiry"
            className="mx-0.5   text-blue"
          >
            contact@mymaani.com
          </a>
          .
        </p>
        <br />
        <Title title="Security of information" />
        <p>
          While we do not collect any personal information through Maani, we are
          committed to ensuring the security and protection of any interactions
          you may have while using our app. <br />
          If you navigate to third-party websites or services, we recommend that
          you review their security policies to understand how they handle the
          security of your personal data.
        </p>
        <br />
        <Title title="Links to third-party websites" />
        <p>
          Maani may contain links to third-party websites or services, such as
          loan merchant pages. These websites may collect personal information
          independently of Maani. We are not responsible for the privacy
          practices of these third-party sites and encourage you to review their
          privacy policies before providing any personal information.
        </p>
        <br />
        <Title title="Changes to this privacy policy" />
        <p>
          We may update this Privacy Policy from time to time to reflect changes
          in our practices or relevant legal requirements. Any updates will be
          posted on this page with the updated effective date.
          <br /> We encourage you to periodically review this Privacy Policy to
          stay informed about how we protect your information and comply with
          privacy regulations.
          <br /> Your continued use of Maani after any changes to this Privacy
          Policy constitutes your acceptance of the revised terms.
        </p>
        <br />
        <Title title="Contact Us" />
        <p>
          If you have any questions, concerns, or feedback about this Privacy
          Policy or Maani’s data practices, please contact us at:
          <br /> <br /> Email:
          <a
            href="mailto:contact@mymaani.com?subject=Support Inquiry"
            className="mx-0.5 text-blue"
          >
            [contact@mymaani.com]
          </a>
          <br />
          <br />
          We take privacy and security seriously, and we are here to address any
          questions or concerns you may have.
        </p>
      </div>
      <Footer />
    </div>
  );
}
